import * as React from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Toolbar from "@mui/material/Toolbar";
import {
  FaUserFriends,
  FaThLarge,
  FaCalendarAlt,
  FaPowerOff,
} from "react-icons/fa";
import { IoMdAddCircleOutline, IoMdMenu } from "react-icons/io";
import { NavLink } from "react-router-dom";
import { MdEventBusy } from "react-icons/md";
import { FiLogOut } from "react-icons/fi";

import { useNavigate } from "react-router-dom";

const drawerWidth = 230;

function EmployeeResponsiveDrawer(props) {
  const navigate = useNavigate();
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  function LogOut() {
    localStorage.removeItem("EmployeeToken");
    navigate("/");
  }

  const drawer = (
    <div className=" h-screen text-black bg-[white]">
      <Toolbar className="h-[12vh] flex gap-2 items-center ">
        <FaUserFriends size={25} color="#9a6aff" />
        <p className=" font-[Righteous] text-2xl text-black">
          HRXpert<small className="  text-xs">EMPLOYEE</small>
        </p>
      </Toolbar>
      <Divider />
      <div className="w-full min-h-[80%] pt-[2em] flex flex-col justify-between">
        <List className="p-3">
          {[
            {
              name: "Dashboard",
              route: "/employee/mainDashboard/main",
              logo: <FaThLarge size={17} />,
            },

            {
              name: "Leaves",
              route: "/employee/mainDashboard/leaves",
              logo: <MdEventBusy size={17} />,
            },

          ].map((item, index) => (
            <ListItem key={index}>
              <NavLink
                to={item.route}
                className=" flex gap-2 w-full h-full items-center justify-center hover:border-[2px] hover:border-[#081226S] pl-3 py-2 rounded-[15px]"
              >
                {item.logo}
                <ListItemText primary={item.name} />
              </NavLink>
            </ListItem>
          ))}
        </List>

        {/* <div className=" h-[7em] flex flex-col w-full justify-center items-center">
        <div className=" p-3 rounded-[2em] text-white bg-[#081226] ">
          <p className=" uppercase">{props.ini}</p>

        </div>
<p className=" font-semibold text-lg">{props.userName}</p>
<p className="text-sm">{props.email}</p>
        </div>*/}
      </div>
      <Divider />
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: {
            sm: `${drawerWidth}px
  
          
          `,
          },
          background: "white",
          boxShadow: "none",
        }}
      >
        <Toolbar>
          <div className=" flex w-full justify-between">
            <button
              className="ml-[95%] flicker-button w-[35px] h-[35px] flex justify-center items-center rounded-[30px]  hover:bg-gray-400 active:bg-gray-500 relative overflow-hidden"
              onClick={LogOut}
            >
              <FiLogOut size={20} color="black" />
            </button>
          </div>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
            color: "black",
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,

          width: { sm: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        <Toolbar />
      </Box>
    </Box>
  );
}

EmployeeResponsiveDrawer.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default EmployeeResponsiveDrawer;
